import { render, staticRenderFns } from "./lookPower.vue?vue&type=template&id=5682229e"
import script from "./lookPower.vue?vue&type=script&lang=js"
export * from "./lookPower.vue?vue&type=script&lang=js"
import style0 from "./lookPower.vue?vue&type=style&index=0&id=5682229e&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports